// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3Nlj0","cardImg":"Card_cardImg__2sOk_","title":"Card_title__3fG9w","diets":"Card_diets__1MGvP"};